import { createFileRoute } from '@tanstack/react-router';
import { DocumentEditorScreen } from '../../../features/documents/document-editor-screen';
import { documentSearchSchema } from '../../../features/documents/document-origin';

/**
 * `?client=` poartă originea: deschis din fișa unui client, „Înapoi" duce acolo, nu la
 * registru (#222). Vezi `document-origin.tsx`.
 */
export const Route = createFileRoute('/_authenticated/documente/$documentId')({
  validateSearch: documentSearchSchema,
  component: DocumentEditorRoute,
});

function DocumentEditorRoute() {
  const { documentId } = Route.useParams();
  const origin = Route.useSearch();

  return <DocumentEditorScreen documentId={documentId} origin={origin} />;
}
